require('../../../modules/es.array.for-each');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').forEach;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/for-each.js
// module id = 4830
// module chunks = 25